import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable } from 'rxjs';

import { Environment } from '../../../environment';
import { GetFlockDataRequest, TimeSeriesResponse } from '../models/flock-report-service.model';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/flock-report/secure`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getFlockData(
    getFlockDataRequest: GetFlockDataRequest,
  ): Observable<TimeSeriesResponse | HttpErrorResponse> {
    return this.http.post<TimeSeriesResponse>(`${this.baseUrl}/flockdata`, getFlockDataRequest, {});
  }
}
